import { STATUS_CODES } from 'utils/Constants'
import { getMiddleware, MiddlewareFunction } from './index'

import ListingQuery from './query.listing.middleware.gql'

export const handleListingPageRedirects: MiddlewareFunction = async (
  { nextContext, apolloClient },
  next
) => {
  const { req, query } = nextContext
  const isEmployeeListing = req?.url?.includes('/care/')
  const isEmployerListing = req?.url?.includes('/jobs/')
  const isListingRoute = (isEmployeeListing || isEmployerListing) && !!query?.slug

  if (!isListingRoute) {
    return next()
  }

  const { data } = await apolloClient.query({
    query: ListingQuery,
    variables: { slug: query?.slug },
  })

  const listingMiddlewares = [handleListingPage404, handleOwnListingRedirect]

  const result = await getMiddleware(listingMiddlewares)({ data, nextContext, apolloClient })

  if (!result) {
    return next()
  } else {
    return result
  }
}

export const handleListingPage404: MiddlewareFunction = async (
  { data: listingData, nextContext },
  next
) => {
  const { req, res } = nextContext
  const isEmployeeListing = req?.url?.includes('/care/')
  const isEmployerListing = req?.url?.includes('/jobs/')

  const isMatchingListingType = listingData.listing?.isProviderListing
    ? isEmployeeListing === true
    : isEmployerListing === true

  if (!listingData.listing || !isMatchingListingType) {
    res.statusCode = 404

    return {
      isServerSideRedirect: false,
      errorCode: STATUS_CODES.CODE404,
    }
  } else {
    return next()
  }
}

export const handleOwnListingRedirect: MiddlewareFunction = async ({ data, nextContext }, next) => {
  const { viewer, listing } = data
  const res = nextContext.res

  if (viewer?.user?.userId === listing?.user?.userId && listing?.slug) {
    res.writeHead(STATUS_CODES.CODE302, {
      Location: `/${listing.slug}`,
    })
    res.end()

    return {
      isServerSideRedirect: true,
      errorCode: null,
    }
  } else {
    return next()
  }
}
